/**
 * Build a deduplicated list of selected account IDs across all usage-dashboard rails.
 * Returns string[] because the nexa-agent /usage/summary endpoint expects string IDs.
 */
export function getSelectedAccountIds(
  videoAccountsDetails: any[],
  appAccountsDetails: any[],
  apiAccountsDetails: any[],
): string[] {
  const seen = new Set<string>();
  const all = [...videoAccountsDetails, ...appAccountsDetails, ...apiAccountsDetails];
  for (const acct of all) {
    if (acct.isSelected) {
      seen.add(String(acct.customerId));
    }
  }
  return Array.from(seen);
}

/**
 * Format a moment-compatible date as YYYY-MM-DD (the only format the
 * nexa-agent validateUsageRange accepts).
 */
export function formatDateYMD(momentDate: any): string {
  return momentDate.format('YYYY-MM-DD');
}
